import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfExpandableCard.module.scss';
import { Card, Image, Heading, RichText, Accordion, AccordionHeading, AccordionDetails, AccordionItem } from '@/components';

let cx = classNames.bind(styles);

export default function AcfExpandableCard(props) {
	const { expandableCard, attributes, clientId } = props;
	const className = attributes.className?.split(' ') || [];

	return (
		<Card id={attributes.anchor} className={cx(['ns_expandable-card', 'expandable-card', ...className])}>
			<Accordion id={clientId}>
				<AccordionItem className={cx('expandable-card-item')}>
					<AccordionHeading className={cx('expandable-card-header')}>
						{expandableCard.headingIcon && <Image className={cx('expandable-card-image')} image={expandableCard.headingIcon} width={expandableCard.iconWidth} />}
						{expandableCard.headingText && <Heading level={expandableCard.headingLevel}>{expandableCard.headingText}</Heading>}
					</AccordionHeading>
					<AccordionDetails className={cx('expandable-card-body')}>
            {expandableCard.details && <RichText className={cx('expandable-card-body-text')} html={expandableCard.details} />}
					</AccordionDetails>
				</AccordionItem>
			</Accordion>
		</Card>
	);
}

AcfExpandableCard.fragments = {
	key: `AcfExpandableCardFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfExpandableCardFragment on AcfExpandableCard {
			attributes {
				anchor
				className
				fullHeight
			}
			expandableCard {
				headingIcon {
					...ImageFragment
				}
				headingText
        headingLevel
        iconWidth
				details
			}
			clientId
		}
	`,
};

AcfExpandableCard.config = {
	name: 'AcfExpandableCard',
};
AcfExpandableCard.displayName = 'AcfExpandableCard';
